import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import React from 'react';

// Admin-only page; the custom AppShell shows its nav entry to admins only and
// the backend rejects non-admins on every /tpa route.
const thirdPartyRouteRef = createRouteRef();

const thirdPartyPage = PageBlueprint.make({
  name: 'third-party-access',
  params: {
    path: '/third-party-access',
    routeRef: thirdPartyRouteRef,
    loader: () =>
      import('./ThirdPartyPage').then(m =>
        React.createElement(m.ThirdPartyPage),
      ),
  },
});

export const thirdPartyModule = createFrontendModule({
  pluginId: 'app',
  extensions: [thirdPartyPage],
});
